(function() {
    'use strict';

    angular.module("product")
        .controller('ProductOptionPricesByQuantityCreate', ProductOptionPricesByQuantityCreate);

    ProductOptionPricesByQuantityCreate.$inject = ['currentOption', 'product', '$uibModalInstance', 'lodashService', 'productoptionpricePermissionsConst'];

    function ProductOptionPricesByQuantityCreate(currentOption, product, $uibModalInstance, lodashService, productoptionpricePermissionsConst) {
        var self = this;

        self.quantityRows = product.quantities.map(function(item) {
            var price = null;
            if (item.prices) {
                price = item.prices[currentOption.option];
            }
            return {
                price: price ? price : 0,
                pk: item.pk,
                product_option: currentOption.option,
                quantity: item.quantity
            };
        });
        self.quantityCols = [{
            title: 'Nakład',
            value: 'quantity',
            type: 'number',
            isEditable: false
        }, {
            title: 'Cena',
            value: 'price',
            type: 'number',
            required: true,
            minValue: 0,
            isEditable: true
        }];
        self.modelPermissions = productoptionpricePermissionsConst;

        self.ok = ok;
        self.onQuantityEdit = onQuantityEdit;

        function ok() {
            $uibModalInstance.close();
        }

        function onQuantityEdit(row) {
            var quantity = lodashService.find(product.quantities, function(quantity) {
                return quantity.pk === row.pk;
            });

            if (!quantity.prices) {
                quantity.prices = {};
            }

            quantity.prices[row.product_option] = row.price;
        }
    }
})();
